<app-header *ngIf="!isHelenaRoute" [bannerImage]="banner"></app-header>
<app-header-helena
  *ngIf="isHelenaRoute"
  [bannerImage]="banner"
></app-header-helena>

<h2 i18n="@@Search">Search History</h2>
<button
  *ngIf="searchHistoryResult.length > 0"
  class="btn" i18n="@@clearhistory"
  (click)="clearHistory()"
>
  Clear History
</button>

<div *ngIf="searchHistoryResult.length == 0" class="alert alert-warning" i18n="@@searchhistoryempty">
  Search history is empty
</div>

<table *ngIf="searchHistoryResult.length > 0" class="table-yara">
  <thead>
    <tr>
      <th i18n="@@Date Searched">Searched On</th>
      <th i18n="@@Criteria">Criteria</th>
      <th i18n="@@NumberResult">Results</th>
      <th i18n="@@ResultType">Result Type</th>
    </tr>
  </thead>
  <tbody>
    
    <tr
      class="tankmixResultRow historyRow clickable"
      *ngFor="let result of searchHistoryResult; let i = index"
      (click)="selectedRow(i)"
    >
 
      <td>
        {{ result.at | date:"yyyy-MMM-dd HH:mm:ss" }}
      </td>
      <td>
        <span *ngIf="result.criteria.countryCode != null">Country:{{ result.criteria.countryCode }}</span
        >
        <span *ngIf="result.criteria.yaraChemicalId != null"
          >Yara Product:
          {{ result.criteria.yaraChemicalId.name }}</span
        >
        <span *ngIf="result.criteria.yaraProductCode != null"
          >Yara Product:
          {{ result.criteria.yaraProductCode.name }}</span
        >
        <span *ngIf="result.criteria.agrochemicalCode != null"
          >Agrochemical:
         {{ result.criteria.agrochemicalCode.name }}</span
        >
        <span *ngIf="result.criteria.activeIngredientCode != null"
          >Active Ingredient:
         {{ result.criteria.activeIngredientCode.name }}</span
        >
        <span *ngIf="result.criteria.seedName != null"
          >Seed Name: {{ result.criteria.seedName }}</span
        >
      </td>
      <td>{{ result.resultsReturned }}</td>
      <td>{{ result.kind }}</td>
    
    </tr>
  </tbody>
</table>
